<template>
  <UnopenedLeadCard @close="close" :lead="lead">
    <div class="d-flex">
      <div 
        class="mt-5 rounded-lg px-4 py-3 d-flex align-center justify-center" 
        style="border: 1px solid #7D8E9B; width: 50%"
      >
        <div class="text-center">This referral is <strong><em>FREE!</em></strong></div>
      </div>

      <div 
        class="mt-5 rounded-lg ml-2 px-4 py-3 d-flex elevation-2 align-center justify-center primary white--text"
        style="width: 50%"
        @click="open"
      >
        <div class="text-center d-flex flex-column">
          <div style="font-size: 16px; font-weight: bold;">OPEN HERE</div>
        </div>
      </div>
    </div>

    <div class="mt-5">
      During your trial period, grab as many leads as you want, to connect
      with potential customers.
    </div>

    <v-divider class="my-3" />

    <div>
      After your trial ends, this lead would cost {{ $formatters.currency(lead.market_price_cents) }} 
      <em>(+ tax)</em>. <span class="blue--text text--darken-2">Most of what we collect goes back to the person who sent this lead</span>.
    </div>
  </UnopenedLeadCard>
</template>

<script>
import UnopenedLeadCard from './UnopenedLeadCard.vue'

export default {
  name: 'UnopenedLeadFreeForNow',

  components: { UnopenedLeadCard },

  props: {
    lead: {
      type: Object,
      required: true,
    },
  },

  methods: {
    close() {
      this.$emit('close')
    },

    open() {
      this.$router.push( { name: 'leads', params: { lead_id: this.lead.lead_id }})
    },
  },
}
</script>